import { render, staticRenderFns } from "./OnlCgformTabModal.vue?vue&type=template&id=4dc2b2f4&scoped=true&"
import script from "./OnlCgformTabModal.vue?vue&type=script&lang=js&"
export * from "./OnlCgformTabModal.vue?vue&type=script&lang=js&"
import style0 from "./OnlCgformTabModal.vue?vue&type=style&index=0&id=4dc2b2f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc2b2f4",
  null
  
)

export default component.exports